export class TaxResult {
  transactionTypeName?: string;
  description?: string;
  rate?: number;
  taxPolicyId?: number;
  taxRuleId?: number;
  securityTaxResultItemId?: number;
  taxResultItemTypeId?: number;
  taxResultItemId?: number;

  constructor(taxResult?: TaxResult) {
    this.transactionTypeName = taxResult?.transactionTypeName;
    this.description = taxResult?.description;
    this.rate = taxResult?.rate;
    this.securityTaxResultItemId = taxResult?.securityTaxResultItemId;
    this.taxResultItemTypeId = taxResult?.taxResultItemTypeId;
    this.taxResultItemId = taxResult?.taxResultItemId;
    this.taxPolicyId = taxResult?.taxPolicyId;
    this.taxRuleId = taxResult?.taxRuleId;
  }
}
